import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const SidenavBody = forwardRef((props, ref) => {
  const { as = 'nav', children, ...rest } = props

  const Component = as
  return (
    <Component className="dev_dash__sidenav--body" ref={ref} {...rest}>
      <ul className="dev_dash__sidenav--body__list--container">{children}</ul>
    </Component>
  )
})

SidenavBody.displayName = 'SidenavBody'

SidenavBody.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
